import { render, staticRenderFns } from "./InviteManagerIcon.vue?vue&type=template&id=25569a5b"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25569a5b')) {
      api.createRecord('25569a5b', component.options)
    } else {
      api.reload('25569a5b', component.options)
    }
    module.hot.accept("./InviteManagerIcon.vue?vue&type=template&id=25569a5b", function () {
      api.rerender('25569a5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/paymentV2/InviteManagerIcon.vue"
export default component.exports